module.exports = __webpack_public_path__ + "img/woo-shopify.c001caef.svg";